<template>
	<div
		class="w-1 h-1 mr-2 bg-white rounded-full flex-shrink-0 transform translate-y-[8px]"
	/>
</template>

<script>
export default {
	name: 'BulletPoint'
}
</script>
